import { atom } from "jotai";

// True while GET /payments/settings is in flight (#298) — drives the charge
// dialog's amount-field loading affordance.
export const isFetchingPaymentSettingsAtom = atom<boolean>(false);
